import { render, staticRenderFns } from "./ListChatPersonsFeatured.vue?vue&type=template&id=66409630&scoped=true&"
import script from "./ListChatPersonsFeatured.vue?vue&type=script&lang=js&"
export * from "./ListChatPersonsFeatured.vue?vue&type=script&lang=js&"
import style0 from "./ListChatPersonsFeatured.vue?vue&type=style&index=0&id=66409630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66409630",
  null
  
)

export default component.exports